import DashboardWrapper from '../../Dashboard/components/DashboardWrapper'
import { useGetProfileUserInfo } from '../../../hooks/useGetProfileUserInfo'
import MasterClassView from './components/MasterClassView'

const MasterClass = () => {
  const { data: userData = {}, isLoading } = useGetProfileUserInfo()

  if (isLoading) {
    return <div>CARGANDO...</div>
  }

  return (
    <DashboardWrapper dashboardWrapperClassName="w-100">
      <MasterClassView userData={userData} />
    </DashboardWrapper>
  )
}

export default MasterClass
